import {grey400} from 'material-ui/styles/colors';

const styles = {
    toggleDiv: {
        maxWidth: 300,
        marginTop: 40,
        marginBottom: 5
    },
    toggleLabel: {
        color: grey400,
        fontWeight: 100
    },
    buttons: {
        marginTop: 30,
        float: 'right'
    },
    saveButton: {
        marginLeft: 5
    },
    editBox: {
        marginBottom: 30,
        paddingBottom: 30
    },
    avatar: {
        verticalAlign: 'middle',
        display: 'block',
        margin: 'auto',
        marginBottom: 40
    }
};

export default styles;


// WEBPACK FOOTER //
// src/containers/common/EditProfilePage/EditProfilePage.css.js